/* layout.tsx generated by @compiled/babel-plugin v0.28.8 */
import "./layout.compiled.css";
import { ax, ix } from "@compiled/react/runtime";
import { useEffect, useState } from 'react';
import { element } from '../../core/elements';
import { Icon } from '../icon';
import { ChartMenu } from '../menu';
import { Title, Subtitle } from '../title';
import { jsxs as _jsxs, jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
export const defaultGrid = ['title', 'subtitle', 'legend', 'plot'];
function Layout(_ref) {
  var _ref2, _ordering$plot;
  let {
    children,
    width,
    height,
    gridTemplate,
    hasSubtitle,
    overflow = 'hidden',
    showBorder = true
  } = _ref;
  const ordering = gridTemplate.reduce((acc, key, i) => {
    acc[key] = i + 1;
    return acc;
  }, {});
  const chartOrder = (_ref2 = (_ordering$plot = ordering['plot']) !== null && _ordering$plot !== void 0 ? _ordering$plot : ordering['plot-legend']) !== null && _ref2 !== void 0 ? _ref2 : ordering['legend-plot'];
  const chartFlexDirection = ordering['plot'] || ordering['legend'] ? 'column' : 'row';
  const chartFlexReverse = ordering['legend'] > ordering['plot'] || ordering['plot-legend'] ? '-reverse' : '';
  const [fadeInOpacity, setFadeInOpacity] = useState(0);
  useEffect(() => {
    let isMounted = true;
    const ref = window.requestAnimationFrame(() => {
      // TODO: would be nice to fade in without triggering another render
      if (isMounted) setFadeInOpacity(1);
    });
    return () => {
      isMounted = false;
      window.cancelAnimationFrame(ref);
    };
  }, [setFadeInOpacity]);
  return /*#__PURE__*/_jsx(_Fragment, {
    children: /*#__PURE__*/_jsxs("div", {
      "data-element": "layout",
      style: {
        width: width,
        height: height,
        backgroundColor: "var(--ds-surface, white)",
        border: showBorder ? `1px solid ${"var(--ds-border, lightgrey)"}` : '0px',
        padding: showBorder ? "var(--ds-space-200, 16px)" : 0,
        overflow
      },
      className: ax(["_1e0c1txw _kqswh2mm _4t3i1osq _2lx21bp4 _vchhusvi"]),
      children: [/*#__PURE__*/_jsxs("div", {
        style: {
          order: ordering.title,
          position: 'relative'
        },
        children: [/*#__PURE__*/_jsx(Icon, {}), /*#__PURE__*/_jsx(Title, {})]
      }), /*#__PURE__*/_jsx("div", {
        style: {
          order: ordering.subtitle
        },
        children: hasSubtitle && /*#__PURE__*/_jsx(Subtitle, {})
      }), /*#__PURE__*/_jsx("div", {
        "data-element": "chart",
        style: {
          opacity: fadeInOpacity,
          transition: 'opacity .3s ease-in-out',
          order: chartOrder,
          flexDirection: `${chartFlexDirection}${chartFlexReverse}`
        },
        className: ax(["_1e0c1txw _1ul9idpf _1tkeidpf _16jlkb7n"]),
        children: children
      }), /*#__PURE__*/_jsx(ChartMenu, {})]
    })
  });
}
const _Layout = element(Layout);
export { _Layout as Layout };